/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {AsideMenuItem} from './AsideMenuItem'
import {AuthorizedFunction} from '../../../../app/modules/auth/components/AuthorizedFunction'

export function AsideMenuMain() {
  const intl = useIntl()
  return (
    <>
      <AsideMenuItem
        to='/app/dashboard'
        title='Home'
        fontIcon='bi-house fs-2'
        bsTitle={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        className='py-2'
      />

      {AuthorizedFunction(['admin-sistema']) && (
        <AsideMenuItem
          to='/app/management/falange/missionarias'
          title='Falanges'
          bsTitle='Falanges'
          fontIcon='bi-moon-stars'
          className='py-2'
        />
      )}

      {AuthorizedFunction(['operacional-devas']) && (
        <AsideMenuItem
          to='/app/management/medium/search'
          title='Médiuns'
          bsTitle='Médiuns'
          fontIcon='bi-person-badge'
          className='py-2'
        />
      )}

      {AuthorizedFunction(['admin-sistema', 'autorizador-cadastro']) && (
        <AsideMenuItem
          to='/app/management/templo/search'
          title='Templos'
          bsTitle='Templos'
          fontIcon='bi-houses'
          className='py-2'
        />
      )}

      {AuthorizedFunction(['admin-sistema']) && (
        <AsideMenuItem
          to='/app/management/relatorios/extracao'
          title='Relatórios'
          bsTitle='Relatórios de Extração'
          fontIcon='bi-file-earmark-bar-graph'
          className='py-2'
        />
      )}

      {AuthorizedFunction(['admin-sistema']) && (
        <AsideMenuItem
          to='/app/carteirinha/search'
          title='Identidade'
          bsTitle='Identidade Mediúnica'
          fontIcon='bi-person-vcard-fill'
          className='py-2'
        />
      )}

      {AuthorizedFunction(['admin-master']) && (
        <AsideMenuItem
          to='/app/management/aprovacoes/search'
          title='Aprovações'
          bsTitle='Acompanhamento de Aprovações de Alteração de Ficha'
          fontIcon='bi-clipboard-check'
          className='py-2'
        />
      )}

      {AuthorizedFunction(['admin-master']) && (
        <AsideMenuItem
          to='/app/management/usuarios-keycloak/usuarios'
          title='Usuários'
          bsTitle='Administração de Usuários do Sistema'
          fontIcon='bi-people'
          className='py-2'
        />
      )}
    </>
  )
}
